import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { Formik, Form } from "formik";
import * as Yup from "yup";

import { loginProfessor, verifyOtpAction } from "services/actions";

import { resendActivationData } from "services/api";
import { get_professor_levels } from "services/cms/api";
import { globalData } from "services/cms/actions";
import { withTranslation, Trans } from 'react-i18next';
import {clear} from "services/storage";

import { set, get } from "services/storage";
import { images } from "../../../home/_resources";

import ModalPassword from "../../../children/home/components/ModalPassword"
import ModalCompteSuccess from "../../../children/home/components/ModalCompteSuccess";
import LdsSpinner from 'components/LdsSpinner';

class CommonModalConnexion extends Component {
  constructor(props){
    super(props);
    this.device_width = window.innerWidth;
    this.state = {
      is_tablete: this.device_width < 1200,
      is_mobile: this.device_width < 767,
      open: false,
      success: false,
      messageSuccess: "",
      resend_activation_data: "",
      resend_activation_data_message: "",
      username: "",
      key_inv: this.props.key_inv,
      errorGlobal:"",
      isSubmitting: false,
      // OTP related states
      showOtpInput: false,
      otpData: null,
      otpCode: "",
      otpError: ""
    };
  }

  handleCloseCnxConnexion = () => {
    this.props.handleCloseCnxConnexion();
  };

  handlePasswordReseted = (message) => {
    this.setState({
      success: true,
      messageSuccess: message,
      open: false
    });
  };

  handleCloseSuccess = () => {
    this.setState({
      success: false,
      messageSuccess: ""
    });
  };

  getValidationSchema = () => {
    if (this.state.showOtpInput) {
      return Yup.object().shape({
        otp: Yup.string()
          .length(6, this.props.t("OTP must be 6 digits"))
          .required(this.props.t("OTP required"))
      });
    }
    
    return Yup.object().shape({
      username: Yup.string().required(this.props.t("Username required")),
      password: Yup.string()
        .required(this.props.t("Password required"))
    });
  };

  onOpenModalPassword = () => {
    this.setState({
      open: true
    });
  };

  onCloseModalPassword = () => {
    this.setState({
      open: false
    });
  };

  handleResendActivationData = () => {
    
    let account;
    account = {
      username: this.state.username
    };
    resendActivationData(account)
    .then(data => {
      this.setState({resend_activation_data_message: data.message});
    })
    .catch(err => {
      this.setState(state => ({
        errorGlobal: err.message
      }));
    });
  };

  handleSubmit = form => {
    if (this.state.showOtpInput) {
      return this.handleOtpSubmit(form);
    }

    let loginprof = this.props.addedData || {};
    if(this.props.addedData){
      loginprof.added_action = "add_school";
    }
    loginprof.username = form.username;
    loginprof.password = form.password;
    loginprof.page_front = this.props.pages;
    
    var lev = get("level_groups");
    var current_language = get("current_language"),
      device_token = get("device_token");
    clear();
    set("device_token", device_token);
    set("level_groups", lev);
    set("current_language", current_language);
    
    return this.props
      .dispatch(loginProfessor(loginprof))
      .then(data => {
        if (data.payload.success) {
          this.redirectAfterLogin();
        } else if (data.payload.is_otp) {
          // Handle OTP requirement
          this.setState({
            showOtpInput: true,
            otpData: data.payload,
            errorGlobal: "",
            isSubmitting: false
          });
        }
      })
      .catch(err => {
        var message = err.message || "";
        var resend_activation_data = message.indexOf("mail_not_yet_verified") !== -1 ? "mail" :(message.indexOf("phone_not_yet_verified") !== -1 ? "phone" : "");
        this.setState(state => ({
          errorGlobal: message.replace(",mail_not_yet_verified", "").replace(",phone_not_yet_verified", ""),
          resend_activation_data: resend_activation_data,
          resend_activation_data_message: "",
          username: form.username,
          isSubmitting: false
        }));
      });
  }
    handleOtpSubmit = (form) => {
    const otpData = {
      user_id: this.state.otpData.user_id,
      otp: form.otp,
      ...this.props.addedData
    };

    if(this.props.addedData){
      otpData.added_action = "add_school";
    }
    otpData.page_front = this.props.pages;

    return this.props
      .dispatch(verifyOtpAction(otpData))
      .then(data => {
        if (data.payload.success) {
          this.redirectAfterLogin();
        }
      })
      .catch(err => {
        let errorMessage = err.message || this.props.t("Invalid OTP");
        
        // Handle specific OTP error cases
        if (errorMessage.includes("Invalid OTP") || errorMessage.includes("invalid_otp")) {
          errorMessage = this.props.t("Invalid OTP. Please check the code and try again.");
        } else if (errorMessage.includes("expired") || errorMessage.includes("OTP expired")) {
          errorMessage = this.props.t("OTP has expired. Please request a new code.");
        }
        
        this.setState({
          otpError: errorMessage,
          isSubmitting: false
        });
      });
  };

  redirectAfterLogin = () => {
    const user = get("session_user");
    const current_year = get('current_year');
    if(this.props.pages === "school"){
      if(user.profile.is_escort){
        this.props.history.push("/escort/transport");
      }
      else{
        if(!user.profile.is_school_admin && user.account_type !== 'ch') {
          this.props.dispatch(globalData({
            school_id: user.profile.schools[0].id,
            scholar_year_id: current_year && current_year.id,
            is_prof: true
          }));
        }
        // get_professor_levels().then(response => {
        //   if (response.success) {
        //     set("professor_levels", response.levels);
        //   }
        // });
        this.props.history.push("/");
      }
    // }else if (this.props.pages === "parent") {
    //   if(['pa', 'pr_pa'].indexOf(user.account_type) >= 0 || user.account_type.indexOf('pa') != -1){
    //     this.props.history.push("/parents/dashboard");
    //   }
    //   else if(user.profile.is_escort){
    //     this.props.history.push("/escort/transport");
    //   }
    //   else if(this.props.key_inv){
    //     this.props.dispatch(globalData({}));
    //     this.props.history.push("/parents/dashboard?key_inv=" + this.props.key_inv);
    //   }
    //   else{
    //     if(['pa', 'pr_pa'].indexOf(user.account_type) >= 0){
    //       this.props.dispatch(globalData({}));
    //       this.props.history.push("/parents/dashboard");
    //     }
    //     else
    //       this.props.history.push("/");
    //   }
    }else if (this.props.pages === "professor" || this.props.pages === "parent"){
      if(['pr', 'pr_pa'].indexOf(user.account_type) >= 0 && ((user.schools || user.profile && user.profile.schools || []).length > 0 || user.profile && user.profile.had_sanady_school_from_last_year)){
        if(false && !((user.schools || user.profile && user.profile.schools || []).length > 0)){
          this.props.history.push(`/professor/info_profile`);
        }
        else{
        this.props.dispatch(globalData({
          school_id: user.profile.schools[0].id,
          scholar_year_id: current_year && current_year.id,
          is_prof: true
        }));
        // get_professor_levels().then(response => {
        //   if (response.success) {
        //     set("professor_levels", response.levels);
        //   }
        // });
          if(user.profile.schools.findIndex(sc => sc.group_id == 249) >= 0)
            this.props.history.push(`/professor/activities_prescolaire`);
          else
            this.props.history.push(`/professor/classes`);
        }
      }
      else if(user.profile.is_escort){
        this.props.history.push("/escort/transport");
      }
      else if(user.profile.is_school_admin){
        this.props.history.push("/");
      }
      else if(this.props.key_inv){
        this.props.dispatch(globalData({}));
        this.props.history.push("/parents/dashboard?key_inv=" + this.props.key_inv);
      }
      else if(['pa', 'pr_pa'].indexOf(user.account_type) >= 0){
        this.props.history.push("/parents/dashboard");
      }
      else{
        this.props.history.push("/");
      }
    } else {
      if(user.profile.is_escort){
        this.props.history.push("/escort/transport");
      }
      else if(['pr','pr_pa'].indexOf(user.account_type) >= 0 && ((user.schools || user.profile && user.profile.schools || []).length > 0 || user.profile && user.profile.had_sanady_school_from_last_year)){
        if(false && !((user.schools || user.profile && user.profile.schools || []).length > 0)){
          this.props.history.push(`/professor/info_profile`);
        }
        else{
        this.props.dispatch(globalData({}));
          if(user.profile.schools.findIndex(sc => sc.group_id == 249) >= 0)
            this.props.history.push(`/professor/activities_prescolaire`);
          else
            this.props.history.push(`/professor/classes`);
        }
      }
      else
        this.props.history.push("/");
    }
  };

  handleBackToLogin = () => {
    this.setState({
      showOtpInput: false,
      otpData: null,
      otpCode: "",
      otpError: "",
      errorGlobal: ""
    });
  };

  render() {
    const {resend_activation_data, resend_activation_data_message, isSubmitting, showOtpInput, otpError} = this.state;
    
    return (
        <>
      <Modal
        open={this.props.openProfessor}
        onClose={this.handleCloseCnxConnexion}
        showCloseIcon={false}
        center
        classNames={{
          overlay: { dialogOverlay: "white" },
          modal: { dialog: "white", dialogConnexion: "white", dialogCommonConnexion: "white", web: !(this.state.is_tablete || this.state.is_mobile) ? "white" : "", tablete: this.state.is_tablete && !this.state.is_mobile ? "white" : "", mobile: this.state.is_mobile ? "white" : "" }
        }}
      >
        <div className={"row " + (this.state.is_mobile ? " mobile " : this.state.is_tablete ? " tablete " : "web")}>
          <div className="col col-md-6 form_">
            <div className="connexion_form">
              <h2>
                {showOtpInput ? this.props.t('Enter Verification Code') : this.props.t('Sign in')}
              </h2>
              
              {showOtpInput && (
                <div style={{marginBottom: 15, color: '#666'}}>
                  {this.props.t('A verification code has been sent to your phone. Please enter it below.')}
                </div>
              )}

              <Formik
                key={showOtpInput ? 'otp' : 'login'} // Force re-render when switching forms
                initialValues={showOtpInput ? { otp: "" } : {
                  username: this.props.username || "",
                  password: ""
                }}
                validationSchema={this.getValidationSchema}
                onSubmit={values => {
                  this.setState({
                    isSubmitting: true,
                    otpError: "", // Clear previous OTP errors
                    errorGlobal: "" // Clear previous login errors
                  });
                  this.handleSubmit(values);
                }}
              > 
                {({ errors, touched, values, handleChange }) => {
                  return (<Form>
                    {(this.state.errorGlobal || otpError) && (                    
                      <div className="textErrors" style={{color: "red", paddingBottom: 10, fontSize: "12px"}}>
                        {showOtpInput ? otpError : this.props.t(this.state.errorGlobal)}
                      </div>
                    )}
                    <span
                      className="schoolClose hidden"
                      onClick={() => this.handleCloseCnxConnexion()}
                    >
                    &times;
                  </span>
                  <div className="modalConnexionForm">
                    {showOtpInput ? (
                      // OTP Input Form
                      <div className="connexionLigne">
                        <div className="connexionW100">
                          <label className="hidden">{this.props.t('Enter verification code')}</label>
                          <input 
                            type="text"
                            className={`textInput ${(errors.otp || otpError) && "textInputError"}`}
                            name="otp"
                            value={values.otp}
                            onChange={(e) => {
                              handleChange(e);
                              // Clear OTP error when user starts typing
                              if (this.state.otpError) {
                                this.setState({ otpError: "" });
                              }
                            }}
                            placeholder={this.props.t('Enter 6-digit code')}
                            maxLength="6"
                            pattern="[0-9]*"
                            inputMode="numeric"
                            autoFocus
                          />
                          {errors.otp && touched.otp ? (
                            <div className="textErrors">{errors.otp}</div>
                          ) : null}
                        </div>
                      </div>
                    ) : (
                      // Login Form
                      <div className="connexionLigne">
                        <div className="connexionW100">
                          <label className="hidden">{ this.props.t('Enter your ID') }</label>
                          <input type="text"
                            className={`textInput ${errors.username && "textInputError"}`}
                            name="username"
                            value={values.username}
                            onChange={handleChange}
                            placeholder={ this.props.t('Enter your ID') }
                          />
                          {errors.username && touched.username ? (
                            <div className="textErrors">{errors.username}</div>
                          ) : null}
                        </div>
                        <div className="connexionW100">
                          <label className="hidden">{ this.props.t('Password') }</label>
                          <input type="password"
                            className={`textInput ${errors.password && "textInputError"}`}
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            placeholder={ this.props.t('Password') }
                          />
                          {errors.password && touched.password ? (
                            <div className="textErrors">{errors.password}</div>
                          ) : null}
                        </div>
                      </div>
                    )}
                    
                    <div className="connexionLigne w12 justify-content-between">
                      {showOtpInput ? (
                        <a onClick={this.handleBackToLogin} className="forgot" style={{float:'none'}}>
                          {this.props.t('Back to Login')}
                        </a>
                      ) : (
                        <a onClick={() => this.onOpenModalPassword()} className="forgot" style={{float:'none'}}>
                          { this.props.t('FORGOT PASSWORD?') }
                        </a>
                      )}
                      
                      <div className=' connexion_button'>
                        {isSubmitting && <LdsSpinner type='relative'/>}
                        <button type="submit" className="signin home_btn_connexion" style={{float:'none'}} disabled={isSubmitting}>
                          {showOtpInput ? this.props.t('Verify') : this.props.t('Validate')}
                        </button>
                      </div>
                    </div>
                    
                    {!showOtpInput && resend_activation_data && (
                    <>
                      <div className="connexionLigne w12 resend_activation_data">
                        Resend {resend_activation_data == "mail" ? "link " : "code "} activation?
                        <button className="resend_activation_data_btn" onClick={this.handleResendActivationData}>{ this.props.t('Resend') }</button>
                      </div>
                      {resend_activation_data_message &&
                        <div className="resend_activation_data_message">
                          {resend_activation_data_message}
                        </div>
                      }
                    </>
                    )}
                  </div>
                </Form>);
                }}
              </Formik>
            </div>
          </div>
          <div className="col col-md-6">
          </div>
        </div>
      </Modal>
          <ModalPassword 
            open={this.state.open} 
            pages={this.props.pages} 
            onCloseModalPassword={this.onCloseModalPassword}
            handlePasswordReseted={(message) => this.handlePasswordReseted(message)} />
          <ModalCompteSuccess
            success={this.state.success}
            message={this.state.messageSuccess}
            handleCloseSuccess={this.handleCloseSuccess}
          />
      </>
    );
  }
}

const mapState2Props = state => ({ session: state.session });
export default connect(mapState2Props)(withRouter(withTranslation('translations')(CommonModalConnexion)));
